import { navigate } from 'gatsby'
import moment from 'moment'
import React, { FC } from 'react'

//* Components
import Button from '../../button'
import Typography from '../../typography'
import WrapperImage from '../../wrapperImage'

//* Helpers
import { ModuleNames } from '../../../../constants/componentNames.constants'
import ImgUtil from '../../../../utils/img.utils'
import { getMicrocopyData } from '../../../../utils/microcopy.utils'

type Props = {
  item: any
}

export const GenerateCard: FC<Props> = ({ item }) => {
  if (!item) return null

  const itemData = {
    image: {
      url: item.mainImage?.image?.file?.url || '',
      altText: item.mainImage?.altText || '',
    },
    resourceCategory: {
      title: item.resourceCategory?.title || '',
      number: item.resourceCategory?.number || 0,
      url: '',
      altText: '',
    },
    microcopy: item.microcopy || null,
    body: item.teaserBody || item.h1Title,
    ctaLink: item.slug ? `/${item.slug}` : '',
    date: item.date || '',
    metaInformation: item.metaInformation || [],
  }

  if (itemData.date) {
    const newDate = new Date(itemData.date)
    itemData.date = moment(newDate).format('D MMM YYYY')
  }

  const microcopy =
    getMicrocopyData(itemData.microcopy, itemData.resourceCategory.number, 'primary', 'text') || []

  let cta = itemData.microcopy && itemData.resourceCategory.number && microcopy
  let regularIcon = false
  let title: string = ''

  if (itemData.metaInformation.length > 0) {
    for (let i = 0; i < itemData.metaInformation.length; i++) {
      const customerDetail = itemData.metaInformation[i]

      if (customerDetail.__typename === ModuleNames.TOPIC_CUSTOMER_DETAILS) {
        const customerAltText = customerDetail.whiteLogo?.altText
        const customerImageUrl = customerDetail.whiteLogo?.image?.file?.url

        title = customerDetail.customerName
        itemData.resourceCategory.altText = customerAltText
        itemData.resourceCategory.url = customerImageUrl
        break
      }
    }
  }

  if (!itemData.resourceCategory.url) {
    itemData.resourceCategory.url = item.resourceCategory?.whiteImage?.image?.file?.url
    itemData.resourceCategory.altText = item.resourceCategory?.whiteImage?.altText
    regularIcon = true
  }

  return (
    <div className="RelatedCustomerStories__Item">
      <div onClick={() => navigate(itemData.ctaLink)}>
        <div className="RelatedCustomerStories__Image-Container">
          {itemData.image.url && (
            <WrapperImage
              className="RelatedCustomerStories__BackgroundImg"
              alt={itemData.image.altText}
              src={ImgUtil.getResizedImageUrl(itemData.image.url, '')}
              threshold={650}
            />
          )}

          {itemData.resourceCategory.url && (
            <WrapperImage
              className={`RelatedCustomerStories__WhiteLogo ${
                regularIcon ? 'RelatedCustomerStories__default_logo' : ''
              }`}
              alt={itemData.resourceCategory.altText}
              src={ImgUtil.getResizedImageUrl(itemData.resourceCategory.url, '')}
              threshold={650}
            />
          )}
        </div>

        <div className="RelatedCustomerStories__Text-Container">
          {itemData.resourceCategory.title && (
            <Typography className="RelatedCustomerStories__Category" type="captionAlt">
              {itemData.resourceCategory.title}
            </Typography>
          )}

          {title && <Typography type="header6">{title}</Typography>}

          {itemData.body && (
            <Typography className="RelatedCustomerStories__Body font__inter" type="bodyXSWrapper">
              {itemData.body}
            </Typography>
          )}

          {itemData.ctaLink && cta[0]?.value && (
            <Button
              icon={true}
              href={itemData.ctaLink}
              text={cta[0].value}
              type="text-link"
              size="small"
              theme={'light'}
            />
          )}
        </div>
      </div>
    </div>
  )
}
